export type PdfEngineErrorCode =
  | 'PDF_SCENE_INVALID'
  | 'PDF_ASSET_MISSING'
  | 'PDF_ASSET_INVALID'
  | 'PDF_RASTERIZER_REQUIRED'
  | 'PDF_RASTER_LIMIT'
  | 'PDF_PAGE_OUT_OF_RANGE'
  | 'PDF_FONT_BINDING_REQUIRED'
  | 'PDF_FONT_BYTES_REQUIRED'
  | 'PDF_FONT_INVALID'
  | 'PDF_EXPORT_FAILED';

export class PdfEngineError extends Error {
  readonly code: PdfEngineErrorCode;
  readonly details: Readonly<Record<string, unknown>>;

  constructor(
    code: PdfEngineErrorCode,
    message: string,
    details: Readonly<Record<string, unknown>> = {},
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'PdfEngineError';
    this.code = code;
    this.details = details;
  }
}
